import { cn as e } from "../lib/utils.js";
import * as t from "react";
import { jsx as n } from "react/jsx-runtime";
import * as r from "@radix-ui/react-progress";
//#region src/shadcn/progress-bar.tsx
var i = t.forwardRef(({ className: t, value: i, isLoading: a, ...o }, s) => /* @__PURE__ */ n(r.Root, {
	ref: s,
	className: e("relative h-4 w-full overflow-hidden rounded-full bg-secondary", t),
	...o,
	children: /* @__PURE__ */ n(r.Indicator, {
		className: e("h-full w-full flex-1 bg-primary transition-all", a && "animate-shimmer bg-gradient-to-r from-primary/20 via-primary to-primary/20 bg-[length:200%_100%]"),
		style: { transform: `translateX(-${100 - (i || 0)}%)` }
	})
}));
i.displayName = r.Root.displayName;
//#endregion
export { i as ProgressBar };
